import { render, staticRenderFns } from "./SosvBasket.vue?vue&type=template&id=78b1930a&scoped=true&"
import script from "./SosvBasket.vue?vue&type=script&lang=js&"
export * from "./SosvBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1930a",
  null
  
)

export default component.exports